export default () => {
	// auto imported by nuxt
	const nuxtApp = useNuxtApp()

	return {
		gsap: nuxtApp.$gsap,

		ScrollTrigger: nuxtApp.$ScrollTrigger,
		SplitText: nuxtApp.$SplitText,
		CustomEase: nuxtApp.$CustomEase,
		CustomWiggle: nuxtApp.$CustomWiggle,
	}
}
